export const assetPath = {
  // ! This one is for images, it just switches based on if you're running in dev mode or with packaged files
  data: function() {
    return {
      assetPath: process.env.NODE_ENV === 'production'
        ? '/AwayFromHome/Campaigns/ocs/'
        : 'http://awayfromhome.localtest.me:8080/AwayFromHome/Campaigns/ocs/',
    }
  },
};
